import logo from "./logo.svg";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Dashboard from "./page/Dashboard";
import Login from "./page/Login";
import { Route, Routes, Navigate } from "react-router-dom";
import Managerpage from "./page/Managerpage";
import DashboardHome from "./components/DashboardHome";
import EmployeesPage from "./page/EmployeesPage";
import SupervisorPage from "./page/SupervisorPage";
import Cookies from 'js-cookie';
import Setting from "./page/Setting";
import { APICall } from "./Utls/Api"
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setUser } from "./Redux/UserSlice";
import Department from "./page/Department";
import Subdepartments from "./page/Subdepartments";
import SendNotification from "./page/SendNotification";
function App() {
  // Check if token exists in cookies
  const dispatch = useDispatch()
  const isAuthenticated = !!Cookies.get('token');

  const checkuser = async()=>{
    await APICall("/auth/getUser" , "GET" ).then((res)=>{
      if(res.status){
        console.log("details",res.data)
        dispatch(setUser(res.data))
      }
    }).catch((error)=>{
      Cookies.remove("token")
      // window.location.reload()
    })
  }

  useEffect(()=>{
    checkuser()
  },[])
  return (
    <>
      <Routes>
        {/* Protected routes */}
        <Route 
          path="/" 
          element={isAuthenticated ? <Dashboard /> : <Navigate to="/login" replace />}
        >
          <Route index element={<DashboardHome />} />
          <Route path="manager" element={<Managerpage />} />
          <Route path="employees" element={<EmployeesPage />} />
          <Route path="supervisor" element={<SupervisorPage />} />
          <Route path="settings" element={<Setting />} />
          <Route path="departments" element={<Department />} />
          <Route path="subdepartments" element={<Subdepartments />} />
          <Route path="send-notification" element={<SendNotification />} />
        </Route>
        
        {/* Login route - redirect to dashboard if already logged in */}
        <Route 
          path="/login" 
          element={isAuthenticated ? <Navigate to="/" replace /> : <Login />} 
        />
      </Routes>
    </>
  );
}

export default App;